import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { ComponentProps, useCallback } from 'react';
import { ForceCleanUpSubscriptionModal } from 'RealmModule/components/SubscriptionRealm/ForceCleanUpSubscriptionModal';

export const useForceCleanUpSubscriptionModal = () => {
  const { openModal } = useDynamicModal();

  const openForceCleanUpSubscriptionModal = useCallback(
    (args: Omit<ComponentProps<typeof ForceCleanUpSubscriptionModal>, 'onClose'>) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <ForceCleanUpSubscriptionModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );

  return {
    openForceCleanUpSubscriptionModal,
  };
};
